<template>
<div>
    <div class="box-header">
      <h3 class="box-title title">Citas de Despacho</h3>
    </div>
  <div class="box box-success">
       <div class="box-header title-boreder">
      <h3 class="box-title box-title-sub">
        <img class="icon-space" src='/static/img/icons/search.png' style="padding-bottom:7px"> Buscar Cita</h3>
    </div>
    <div class="box-body">
      <div class="filterContainer">
        <div class="row">
          <div class="col-md-4">
            <div id="divAccountSelect" class="form-group">
              <label>Cuenta</label>  
              <multiselect
                :value="this.selectedAccount"
                selectLabel=""
                selectedLabel=""
                deselectLabel=""
                track-by="name"
                :placeholder="this.selectedAccount.name"
                :allow-empty="false"
                label="name"
                :options="this.optionsAccount"
                @input="onAccountSelect">
                <span slot="noResult">
                  No se encontraron resultados
                </span>
              </multiselect>
            </div>
          </div>
          <div class="col-md-8 form-interspace">
            <div class="form-group pull-left" style="padding-top:25px;">
              <router-link :to="{name: 'DispatchAppointmentsUpload', params: {accountCode: this.selectedAccount.code} }" tag="button" class="btn btn-success">Nuevo Documento</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <br/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" id="dispatchTable">
          <vuetable 
            id="dispatchTable"
            ref="vuetable"
            :api-mode="false"
            :fields="tableFields"
            :data="tableData"
            :css="tableCSS.table"
            @vuetable:loading="onLoading"        
            @vuetable:loaded="onLoaded"
            noDataTemplate="No se encontraron resultados"
          >
          </vuetable>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Vuetable from 'vuetable-2'
import moment from 'moment/moment.js'

export default {
  name: 'DispatchAppointments',
  data () {
    return {
      loader: null,
      selectedAccount: null,
      optionsAccount: null,
      tableData: null,
      tableFields: [
        {
          name: 'accountCode',
          title: 'Cliente',
          callback: 'formatClient'
        },
        {
          name: 'filename',
          title: 'Documento'
        },
        {
          name: 'uploaded',
          title: 'Fecha de Carga',
          callback: 'formatDate'
        },
        {
          name: 'uploadedBy',
          title: 'Cargado Por'
        }
      ],
      tableCSS: {
        table: {
          tableClass: 'table table-striped table-bordered table-hovered',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger'
        }
      },
      tableOptions: {
        headings: {
          accountCode: 'Cliente',
          fileName: 'Documento',
          uploaded: 'Fecha de Carga',
          uploadedBy: 'Cargado Por'
        },
        filterable: false,
        texts: {
          count: ''
        }
      }
    }
  },
  components: {
    Multiselect,
    Vuetable
  },
  computed: {
    ...mapGetters([
      'userClients'
    ])
  },
  created () {
    this.optionsAccount = Array.from(this.userClients)
    this.selectedAccount = this.optionsClient[0]
    this.loadTableData()
  },
  methods: {
    ...mapActions([
      'fetchDispatchAppointmentDocumentList'
    ]),
    loadTableData () {
      this.loader = this.$loading.show({
        loader: 'dots'
      })

      this.fetchDispatchAppointmentDocumentList(this.selectedAccount.code)
      .then((data) => {
        if (data != null) {
          this.tableData = data
          this.loader.hide()
        }
      })
    },
    /* DropDownList Events */
    onAccountSelect (account) {
      this.selectedAccount = account
      this.loadTableData()
    },
    /* Table Events */
    onLoading () {
      this.loader = this.$loading.show({
        loader: 'dots'
      })
    },
    onLoaded () {
      this.loader.hide()
    },
    formatClient (value) {
      return this.optionsClient.filter(item => item.code === value)[0].name
    },
    formatDate (value) {
      return moment(value).format('DD/MM/YYYY')
    }
  },
  destroyed () {
    if (this.loader !== null) {
      this.loader.hide()
    }
  }
}
</script>

<style>

@media screen and (max-width: 600px) {

   #dispatchTable table {
      border: 0;
    }

   #dispatchTable thead {
      display: none;
    }

   #dispatchTable table tr {
      margin-top: 10px;
      margin-bottom: 20px;
      display: block;
	    border:  3px solid;
      border-color:#F2F4F6;
      background-color: white !important;
    }

   #dispatchTable table td {
      display: block;
      border: none !important;
      font-size: 13px;
      text-align: right;
      
    }

   #dispatchTable table td:last-child {
      border-bottom: 0;
    }

    #dispatchTable table td div::before{
      content: attr(id);
      float: left;
      text-transform: uppercase;
      font-weight: bold;
    }
    	#dispatchTable	tbody{
			line-height:0!important;
		}

    .table-btn {
    float: none !important;
    background: none !important;
}

  }


</style>



// WEBPACK FOOTER //
// DispatchAppointments.vue?45dff4c2